import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, Grid, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { formatTimestamp } from '@nu-art/ts-common';
import './Component_FindingGroup.scss';
import { ModuleFE_AdvisorSession } from '@app/advisor-frontend';
import { ICONS } from '@app/styles';
import { Component_FindingResults } from '../Component_FindingResults/Component_FindingResults.js';
import { FindingType_Textual } from '@app/advisor-shared';
export class Component_FindingGroup extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.result = nextProps.result;
        state.sectionConfig = nextProps.sectionConfig;
        state.showPreviousResults ??= false;
        return state;
    }
    //######################### Logic #########################
    isSameDay = (timestamp) => {
        const date = new Date(timestamp);
        const today = new Date();
        return today.getFullYear() === date.getFullYear()
            && today.getMonth() === date.getMonth()
            && today.getDate() === date.getDate();
    };
    getTimestampString = (timestamp) => {
        if (this.isSameDay(timestamp))
            return formatTimestamp('hh:mmA', timestamp);
        return formatTimestamp('MM.DD.YYYY • hh:mmA', timestamp);
    };
    //######################### Render #########################
    render() {
        const result = this.state.result;
        if (!result.order)
            return this.render_Ungrouped();
        return _jsxs(LL_V_L, { className: 'finding-group', children: [_jsx("div", { className: 'finding-group__title', children: result.order.name }), this.renderBlock(result.blocks[0]), this.state.showPreviousResults && result.blocks.map((block, index) => index === 0 ? undefined : this.renderBlock(block)), this.renderPreviousResultsControl()] });
    }
    render_Ungrouped = () => {
        const gridClassName = _className('findings-grid', this.state.sectionConfig.allowFindingEdit && 'allow-edit');
        const results = this.state.result.blocks[0].results;
        return _jsx(Grid, { className: gridClassName, children: results.map(result => _jsx(Component_FindingResults, { findingResults: result, sectionConfig: this.state.sectionConfig, forceTimestampOnTextual: true }, result.variable._id)) });
    };
    //######################### Render - Result #########################
    renderBlock = (block) => {
        const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
        const className = _className('finding-group__result', encounterId !== block.rtOrder?.encounterId && 'fade');
        return _jsxs(LL_V_L, { className: className, children: [this.renderBlock_Timestamp(block), this.renderResult_Findings(block)] }, block.rtOrder?._id);
    };
    renderBlock_Timestamp = (block) => {
        const hasTextualFindings = block.results.find(result => result.findings[0].type === FindingType_Textual);
        if (hasTextualFindings)
            return;
        const timestampVal = block.rtOrder?.timeResulted ?? block.rtOrder?.timeAccepted ?? block.rtOrder?.timeCreated ?? block.rtOrder?.__created;
        const timestamp = this.getTimestampString(timestampVal);
        return _jsx("div", { className: 'finding-group__result-timestamp', children: timestamp });
    };
    renderResult_Findings = (block) => {
        const className = _className('finding-group__findings', this.state.sectionConfig.allowFindingEdit && 'allow-edit');
        const timestampVal = block.rtOrder?.timeResulted ?? block.rtOrder?.timeAccepted ?? block.rtOrder?.timeCreated ?? block.rtOrder?.__created;
        const timestamp = this.getTimestampString(timestampVal);
        return _jsx(Grid, { className: className, children: block.results.map(results => _jsx(Component_FindingResults, { findingResults: results, sectionConfig: this.state.sectionConfig, overrideValue: timestamp }, results.variable._id)) });
    };
    //######################### Render - Controls #########################
    renderPreviousResultsControl = () => {
        const results = this.state.result;
        if (results.blocks.length <= 1)
            return;
        if (this.state.showPreviousResults)
            return _jsxs(LL_H_C, { className: 'finding-group__previous-results-control', onClick: () => this.setState({ showPreviousResults: false }), children: [_jsx(ICONS.advisor_v5_arrow.component, {}), "See Recent Results"] });
        return _jsxs(LL_H_C, { className: 'finding-group__previous-results-control', onClick: () => this.setState({ showPreviousResults: true }), children: [_jsx(ICONS.advisor_v5_arrow.component, { className: 'flip' }), "See Previous Results"] });
    };
}
//# sourceMappingURL=Component_FindingGroup.js.map